import { Component, OnInit,  ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { LoantransactionService } from "../../shared/loantransaction.service";
import { PrintloantransactionlistService } from "../../shared/print/printloantransactionlist.service";

@Component({
  selector: 'app-loantransactionlist',
  templateUrl: './loantransactionlist.component.html',
  styleUrls: ['./loantransactionlist.component.css']
})
export class LoantransactionlistComponent implements OnInit {
  
  AddButtonText: string;
  displayedColumns: string[] = ['TransactionNo','CustomerName', 'Centre', 'Date', 'New'];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ParentTransactionNo : number;
  ToReceiptForm: Boolean = false;  // handling FetchLoantransactionList()

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
              private loantransactionService: LoantransactionService,
              private datePipe: DatePipe, private printloantransactionlistService : PrintloantransactionlistService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(param => {
      this.ParentTransactionNo = + param['Id'];  //Parent voucher Id
    });

    this.GetLoanTransactionList();
    this.dataSource.paginator = this.paginator;
  }

  GetLoanTransactionList(){
    this.loantransactionService.FetchLoantransactionList(this.ToReceiptForm)
      .toPromise()
      .then(data => {

        console.log(data);
        this.dataSource.data = data;
      })
      .catch(err => { console.log(err) });
  }
  
  AddNew(){
    this.router.navigate(['/loantransaction']);
  }

  Print(txt: any,loanTransactionItem : any){
    // console.log(loanTransactionItem);
    // this.printloantransactionlistService.FetchReportLoantransactionList(loanTransactionItem);

    this.printloantransactionlistService.GenerateReport(this.ToReceiptForm,loanTransactionItem);
  }

  applyFilter(filterValue: string) {

    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  
}
